import { createAction } from '@reduxjs/toolkit'

import actionTypes from './actionTypes'

// Sets the full list of feature access entries
// Payload: Array<{ featureCode: string, isEnabled: boolean }>
export const setFeatureList = createAction(actionTypes.SET_FEATURE_LIST)

// Upserts a single feature access entry
// Payload: { featureCode: string, isEnabled: boolean }
export const upsertFeature = createAction(actionTypes.UPSERT_FEATURE)
